import './Spinner.scss';

export const Spinner = () => (
    <div className="spinner-overlay">
        <div className="spinner-container"></div>
    </div>
);

